import axios from 'axios'

export default function () {
    const token = document.querySelector('[name="csrf-token"]')?.content || { content: 'no-csrf-token' }
    axios.defaults.headers.common['X-CSRF-Token'] = token
}
